import React from "react";
import {Card} from "../modules/Contacts/index";

export function ContactCardPage(props) {
  return (
    <Card {...props} />
  );
}
